// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section__OtherProductsCard-module--Ym6gy {
    padding: 0 var(--space-md) var(--space-3xl);
}

.card__OtherProductsCard-module--qTP5q {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(340px, 100%), 1fr));
    align-items: center;
    gap: var(--space-lg);
    padding: var(--space-lg);
    border: none;
    border-radius: var(--home-radius-3xl);
    color: var(--home-color-secondary-text);
    text-decoration: none;
    transition: filter 0.2s ease;
}

.card__OtherProductsCard-module--qTP5q:hover {
    filter: brightness(0.97);
}

@media (prefers-reduced-motion: reduce) {
    .card__OtherProductsCard-module--qTP5q {
        transition-duration: 0.01s;
    }
}

.text__OtherProductsCard-module--zl9zy {
    display: flex;
    flex-direction: column;
    gap: var(--space-2xs);
}

.heading__OtherProductsCard-module--p0Hjc {
    margin: 0;
    font-size: clamp(28px, 3vw, 38px);
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.05;
}

.body__OtherProductsCard-module--eJHWX {
    margin: 0;
    font-size: 17px;
    line-height: 1.55;
}

.pill__OtherProductsCard-module--b0Zyp {
    justify-self: end;
    display: inline-flex;
    align-items: center;
    gap: var(--space-xs);
    padding: var(--space-sm) var(--space-md);
    border-radius: var(--home-radius-pill);
    background: var(--color-surface-inverse);
    color: var(--color-text-on-brand);
    font-weight: 700;
    font-size: 17px;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/OtherProductsCard.module.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sEAAsE;IACtE,mBAAmB;IACnB,oBAAoB;IACpB,wBAAwB;IACxB,YAAY;IACZ,qCAAqC;IACrC,uCAAuC;IACvC,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,iCAAiC;IACjC,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,wCAAwC;IACxC,sCAAsC;IACtC,wCAAwC;IACxC,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB","sourcesContent":[".section {\n    padding: 0 var(--space-md) var(--space-3xl);\n}\n\n.card {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(340px, 100%), 1fr));\n    align-items: center;\n    gap: var(--space-lg);\n    padding: var(--space-lg);\n    border: none;\n    border-radius: var(--home-radius-3xl);\n    color: var(--home-color-secondary-text);\n    text-decoration: none;\n    transition: filter 0.2s ease;\n}\n\n.card:hover {\n    filter: brightness(0.97);\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .card {\n        transition-duration: 0.01s;\n    }\n}\n\n.text {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-2xs);\n}\n\n.heading {\n    margin: 0;\n    font-size: clamp(28px, 3vw, 38px);\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    line-height: 1.05;\n}\n\n.body {\n    margin: 0;\n    font-size: 17px;\n    line-height: 1.55;\n}\n\n.pill {\n    justify-self: end;\n    display: inline-flex;\n    align-items: center;\n    gap: var(--space-xs);\n    padding: var(--space-sm) var(--space-md);\n    border-radius: var(--home-radius-pill);\n    background: var(--color-surface-inverse);\n    color: var(--color-text-on-brand);\n    font-weight: 700;\n    font-size: 17px;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `section__OtherProductsCard-module--Ym6gy`,
	"card": `card__OtherProductsCard-module--qTP5q`,
	"text": `text__OtherProductsCard-module--zl9zy`,
	"heading": `heading__OtherProductsCard-module--p0Hjc`,
	"body": `body__OtherProductsCard-module--eJHWX`,
	"pill": `pill__OtherProductsCard-module--b0Zyp`
};
export default ___CSS_LOADER_EXPORT___;
